module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.detailsShow) ? _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    staticClass: "details-main"
  }, [_c('h1', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.seller.name))]), _vm._v(" "), _c('div', {
    staticClass: "star-wrapper"
  }, [_c('star', {
    attrs: {
      "size": 48,
      "score": _vm.seller.score
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("优惠信息")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), (_vm.seller.supports) ? _c('ul', {
    staticClass: "supports"
  }, _vm._l((_vm.seller.supports), function(item) {
    return _c('li', {
      staticClass: "support-item"
    }, [_c('support-icon', {
      staticClass: "icon",
      attrs: {
        "supportType": item.type,
        "iconType": 2
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.description))])], 1)
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("商家公告")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bulletin"
  }, [_vm._v(_vm._s(_vm.seller.bulletin))])]), _vm._v(" "), _c('div', {
    staticClass: "details-close"
  }, [_c('i', {
    staticClass: "icon-close",
    on: {
      "click": _vm.toggleShow
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bdc4b1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SellerDetails.vue
// module id = 243
// module chunks = 1